export enum UtilisateursPath {
  ROOT = '',
  EDITION = 'edition-utilisateur',
  EDITION_GENERAL = 'general',
  ID_UTILISATEUR_PARAM = 'idUtilisateur',
  GUID_UTILISATEUR_PARAM = 'guidUtilisateur',
}
